module.exports = "/_next/static/images/mo-0dc09f497aa5f082cc54dec9022dbc27.svg";